import { Component, computed, input, output, signal, ViewEncapsulation } from '@angular/core';
import { MatError } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { Country, COUNTRY_LIST, DEFAULT_COUNTRY } from '@core';

import { SearchInputComponent } from '../search-input/search-input.component';

@Component({
  encapsulation: ViewEncapsulation.None,
  imports: [MatSelectModule, MatIconModule, MatError, SearchInputComponent],
  selector: 'avs-country-select',
  styleUrl: './country-select.component.scss',
  templateUrl: './country-select.component.html',
})
export class CountrySelectComponent {
  changed = output<Country>();
  value = input<string>(DEFAULT_COUNTRY.code);
  selectClass = input('select-classic max-w-[180px]');
  showPhoneCode = input(false);
  hasError = input(false);

  protected searchValue = signal('');
  protected filteredCollection = computed(() => {
    const search = this.searchValue().toLowerCase();

    return COUNTRY_LIST
      .filter(country => country.name.toLowerCase().includes(search) || (this.showPhoneCode() && country.phoneCode.includes(search)))
      .sort((a, b) => this.showPhoneCode() ? a.code.localeCompare(b.code) : a.name.localeCompare(b.name));
  });
  protected selectedCountry = computed(() =>
    COUNTRY_LIST.find(country => country.code === this.value()) ?? DEFAULT_COUNTRY,
  );

  protected valueChanged(code: string) {
    const country = COUNTRY_LIST.find(country => country.code === code) ?? DEFAULT_COUNTRY;

    this.changed.emit(country);
  }
}
